<template>
  <div>
    <b-table-simple v-if="submital" borderless small >
      <b-tbody>
        <b-tr v-for="(row, index) in tableRows" :key="index">
          <b-th style="width: 180px">{{ row.label }}</b-th>
          <b-td v-if="row.show">
            <span v-if="row.link" class="clickable text-primary" style="text-decoration: underline;" @click="goToLink">
              <span>{{ row.value }}</span>
            </span>
            <span v-else>{{ row.value }}</span>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'SubmitalSummary',
  props: {
    ready: Boolean
  },
  data () {
    return {
      routesMap: {
        'CZ': '/corredizos',
        'AB': '/abatibles',
        'CT': '/cortinas',
        'SE': '/seccionales'
      }
    }
  },
  computed: {
    ...mapState ({
      submital: state => state.configurator.submital,
      configurable: state => state.configurator.configurable
    }),
    ...mapGetters (['submitalCategory', 'isSeccional', 'isCortina']),
    configurableHeight () {
      let height
      if (!this.configurable) return null

      if (this.submitalCategory !== 'Access') return null

      if (this.isSeccional || this.isCortina) {
        if (this.configurable.desnivel == 'Plano') {
          height = this.configurable.dim_h
        } else if (this.configurable.desnivel == 'Desnivel izquierdo') {
          height = this.configurable.dim_hi
        } else {
          height = this.configurable.dim_hd
        }
      } else {
        if (this.configurable.dim_hi && this.configurable.dim_hd) {
          height = this.configurable.dim_hi > this.configurable.dim_hd ? this.configurable.dim_hi : this.configurable.dim_hd
        }
      }
      return height
    },
    tableRows() {
      if (!this.configurable || !this.submital) return []

      if (this.submitalCategory === 'Access') {
        return [
          { label: 'Cantidad:', value: this.submital.quantity, show: true },
          { label: 'Ancho:', value: `${this.configurable.dim_a} cm`, show: !!this.configurable.dim_a },
          { label: 'Alto:', value: `${this.configurableHeight} cm`, show: !!this.configurableHeight },
          { label: 'Peso aproximado:', value: `${this.configurable.peso_aproximado} kg`, show: !!this.configurable.peso_aproximado },
          { label: ' Submital relacionado:', value: this.submital.related_configurable?.acceso_id || this.submital.related_configurable?.submital_no || '', show: true, link: true }
        ]
      }

      if (this.submitalCategory === 'Anden') {
        return [
          { label: 'Cantidad:', value: this.submital.quantity, show: true },
          { label: 'Nivelador:', value: this.configurable.leveler === 'manual' ? 'Manual' : 'Automático', show: !!this.configurable.leveler },
          { label: 'Vehículos que arriban:', value: this.configurable.arriving_vehicle_type, show: !!this.configurable.arriving_vehicle_type },
          { label: 'Producto:', value: this.configurable.leveler_product, show: !!this.configurable.leveler_product },
          { label: ' Submital relacionado:', value: this.submital.related_configurable?.acceso_id || this.submital.related_configurable?.submital_no || '', show: true, link: true }
        ]
      }

      if (this.submitalCategory === 'Puerta') {
        return [
          { label: 'Tipo de puerta:', value: this.configurable.door_type, show: !!this.configurable.door_type },
          { label: 'Configuración:', value: this.configurable.door_configuration, show: !!this.configurable.door_configuration },
          { label: ' Submital relacionado:', value: this.submital.related_configurable?.acceso_id || this.submital.related_configurable?.submital_no || '', show: true, link: true }
        ]
      }

      if (this.submitalCategory === 'ControlAcceso') {
        return [
          { label: 'Cantidad:', value: this.submital.quantity, show: true },
          { label: 'Tipo de acceso:', value: this.configurable.access_control_type_id && this.configurable.access_control_type ? this.configurable.access_control_type.category : 'Pendiente', show: true },
          { label: ' Paso a controlar:', value: this.configurable.access_control_type_id && this.configurable.access_control_type ? this.configurable.access_control_type.name : 'Pendiente', show: true },
          { label: ' Submital relacionado:', value: this.submital.related_configurable?.acceso_id || this.submital.related_configurable?.submital_no || '', show: true, link: true }
        ]
      }

      if (this.submitalCategory === 'Generico') {
        let notes = this.configurable.notes ? this.configurable.notes : ''
        notes = notes.length > 200 ? notes.slice(0, 200) + '...' : notes
        return [
          { label: 'Cantidad:', value: this.submital.quantity, show: true },
          { label: 'Comentario:', value: notes, show: true },
        ]
      }

      return []
    }
  },
  methods: {
    goToLink () {
      const relatedConfigurable = this.submital?.related_configurable
      if (!relatedConfigurable) return

      const identifier = relatedConfigurable.acceso_id || relatedConfigurable.submital_no
      const relatedId = relatedConfigurable.id

      console.log(relatedId, identifier)

      if (!identifier || !relatedId) return

      const submitalCode = identifier.split('-')[0]
      const targetRoute = this.routesMap[submitalCode] || '/app/prod/submitals'
      const fullPath = `${targetRoute}/${relatedId}`

      this.$router.replace(fullPath).then(() => {
        location.reload()
      })
    }
  }
}
</script>